export default __webpack_public_path__ + "static/media/arrow-alt-circle-right.8d1fd24f.svg";